import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { postsAPI } from '../../services/api';
import './AnnouncementDetailPage.css';

const AnnouncementDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [announcement, setAnnouncement] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAnnouncement = async () => {
            try {
                // Fetch the consolidated feed which includes the current announcement
                const response = await postsAPI.getConsolidatedFeed({ postPage: 1 });
                if (response.data?.status === 'success' && response.data?.data?.announcement) {
                    setAnnouncement(response.data.data.announcement);
                }
            } catch (error) {
                console.error('Error fetching announcement details:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAnnouncement();
    }, []);

    if (isLoading) {
        return (
            <div className="announcement-detail-loading">
                <div className="spinner"></div>
                <p>{t('common.loading')}</p>
            </div>
        );
    }

    if (!announcement) {
        return (
            <div className="announcement-detail-error">
                <h2>{t('common.noData')}</h2>
                <button onClick={() => navigate('/social')} className="back-btn">
                    {t('common.back') || 'Go Back'}
                </button>
            </div>
        );
    }

    const { title, message, image, type, created_at } = announcement;

    return (
        <div className="announcement-detail-page" dir={i18n.dir()}>
            <div className="announcement-detail-container">
                <header className="announcement-detail-header">
                    <button onClick={() => navigate('/social')} className="close-btn">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                    <div className={`type-badge badge-${type || 'info'}`}>
                        {type || 'System'}
                    </div>
                </header>

                <main className="announcement-detail-content">
                    {image && (
                        <div className="announcement-image-wrapper">
                            <img src={image} alt={title} className="announcement-full-image" />
                        </div>
                    )}
                    
                    <h1 className="announcement-title">{title}</h1>
                    
                    <div className="announcement-meta">
                        <span className="announcement-date">
                            {new Date(created_at || Date.now()).toLocaleDateString(i18n.language, {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                    </div>

                    <div className="announcement-body">
                        {message}
                    </div>
                </main>

                <footer className="announcement-detail-footer">
                    <button onClick={() => navigate('/social')} className="action-btn">
                        {t('common.close')}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default AnnouncementDetailPage;
